const selectors = {
  invoicesList: (state) => state.invoices.invoicesList,
  userInvoice: (state) => state.invoices.invoice,
  invoiceSchedules: (state) => state.invoices.invoiceSchedules,
  filters: (state) => state.invoices.filters,
  pagination: (state) => state.invoices.pagination,
  sort: (state) => state.invoices.sort,

  loadingListStatus: (state) => state.invoices.loadingListStatus,
  loadingInvoice: (state) => state.invoices.loadingInvoice,
  loadingInvoiceSchedules: (state) => state.invoices.loadingInvoiceSchedules,
};

export { selectors };
